import Axios from '../axios-instance';

const ScrapsAPI = {
  getScrapGrid: body => {
    return Axios.post('/Scrap/Get', body).then(({ data }) => data);
  },
  exportToExcel: body => {
    return Axios.post('/Scrap/exportToExcel', body, { responseType: 'arraybuffer' }).then(({ data }) => data);
  },
};

export default ScrapsAPI;
